import {
    GET_CUSTOMER_DOCS_DETAILS_FAILURE,
    GET_CUSTOMER_DOCS_DETAILS_SUCCESS,
    GET_CUSTOMER_DOCS_DETAILS_LOADING,
} from '../../actions/types';

const INITIAL_STATE = {
    customerDocsDetails: {
        get: {
            loading: false,
            reset: false,
            success: {
                ok: false,
                data: null,
            },
            failure: {
                error: false,
                message: '',
            },
        }
    }
};




const customerDocsDetailsReducers = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_CUSTOMER_DOCS_DETAILS_LOADING:
            return {
                ...state,
                customerDocsDetails: {
                    ...state.customerDocsDetails,
                    get: {
                        ...state.customerDocsDetails.get,
                        loading: true,
                        reset: false,
                        success: {
                            ...state.customerDocsDetails.get.success,
                            ok: false,
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case GET_CUSTOMER_DOCS_DETAILS_SUCCESS:
            return {
                ...state,
                customerDocsDetails: {
                    ...state.customerDocsDetails,
                    get: {
                        ...state.customerDocsDetails.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.customerDocsDetails.get.success,
                            ok: true,
                            data: action.payload,
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case GET_CUSTOMER_DOCS_DETAILS_FAILURE:
            return {
                ...state,
                customerDocsDetails: {
                    ...state.customerDocsDetails,
                    get: {
                        ...state.customerDocsDetails.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.customerDocsDetails.get.success,
                            ok: false,
                            data: null,
                        },
                        failure: {
                            error: true,
                            message: action.payload.message,
                        },
                    },
                },
            };

    }
    return state;
}

export default customerDocsDetailsReducers;